import { AGENT_STEP_PILL_VARIANTS } from './constants';
import { getVariantColor } from './utils.js?vue3';
export default {
    name: 'WorkplanStatusBar',
    props: {
        variant: {
            type: String,
            required: true,
            validator: (value)=>Object.keys(AGENT_STEP_PILL_VARIANTS).includes(value)
        }
    },
    computed: {
        barBgClass () {
            return {
                backgroundColor: getVariantColor(this.variant)
            };
        }
    }
};
